import React from "react";

export const CardListContext = React.createContext({callBack: () => null});
